// M9 — Manager tour: External Cooperation. 1 step on /externalcooperations.
export default {
  key: 'M9',
  route: '/externalcooperations',
  steps: [
    {
      id: 'list',
      target: '[data-tour-id="externalcooperations.list"]',
      title: 'External Cooperation',
      desc: 'External Cooperation tracks production work handed off to third-party suppliers. Each row records the outsourced operation and its return.',
    },
  ],
}
